import { Field } from '@qid/field';
import { AccountType } from "@qid/core";
import { Participant } from "../model/participant";
import { ShareStatus } from "../enum/share-status.enum";


export class CreateShareDto {

  organisationId: string | null = null;
  templateId: string | null = null;
  scan: string | null = null;

}
